// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabRatingCardComments-modulecomments__c56Lt";
var _2 = "RequestProfileTabRatingCardComments-modulecommentsButton__pWejL";
var _3 = "RequestProfileTabRatingCardComments-modulefooter__tl7sI";
export { _1 as "comments", _2 as "commentsButton", _3 as "footer" }
